import { useMemo, useState } from 'react';
import { currentYearMonth } from '../utils/maintenanceExecutionMapper';
import {
	hasPlanningBudget,
	mapPlanningBudgetMonths,
	mapPlanningBudgetTable,
	toApiPeriod,
	type PlanningSectorResult,
} from '../utils/planningTableMapper';

export const usePlanningBudget = (
	sectors: PlanningSectorResult[],
	fertilizers: Array<{ _id: string; name?: string; commercialName?: string }>
) => {
	const [selectedBudgetPeriod, setSelectedBudgetPeriod] = useState('');

	const hasBudget = useMemo(() => hasPlanningBudget(sectors), [sectors]);
	const budgetMonths = useMemo(() => mapPlanningBudgetMonths(sectors), [sectors]);
	const activeBudgetPeriod = useMemo(() => {
		const periods = budgetMonths.map((month) => month.period);
		if (periods.includes(selectedBudgetPeriod)) return selectedBudgetPeriod;
		const currentPeriod = toApiPeriod(currentYearMonth());
		return periods.includes(currentPeriod) ? currentPeriod : (periods[0] ?? '');
	}, [budgetMonths, selectedBudgetPeriod]);
	const budgetTable = useMemo(
		() => mapPlanningBudgetTable(sectors, activeBudgetPeriod, fertilizers),
		[activeBudgetPeriod, fertilizers, sectors]
	);

	return {
		hasBudget,
		budgetMonths,
		activeBudgetPeriod,
		setSelectedBudgetPeriod,
		budgetTable,
	};
};
